export default "__VITE_ASSET__wEc8Hg8b__"